import { AsyncLinks } from './AsyncLinks';
import { useInvoiceApi } from '~/lib/api/invoice/use-invoice-api';
import { useMemo, useState } from 'react';
import useOnLoad from '~/routes/use-on-load';

const OrderInvoice: React.FC<{
  orderId: number;
  wrapper: (children: React.ReactNode) => React.ReactNode;
  title?: string;
  titleComponent?: React.ReactNode;
}> = ({ orderId, wrapper, title, titleComponent }) => {
  const { getSignedInvoiceUrl } = useInvoiceApi();
  const [presigned, setPresigned] = useState<string>(null);

  useOnLoad(() => {
    const loadInvoice = async () => {
      if (isNaN(orderId)) {
        return;
      }
      const res = await getSignedInvoiceUrl(orderId);
      if (res.success && res.result.preSignedUrl) {
        setPresigned(res.result.preSignedUrl);
      }
    };
    loadInvoice();
  });

  const links = useMemo(() => {
    if (presigned) {
      return [
        {
          Label: `Download\nInvoice`,
          Type: 'ORDER-INVOICE_DOWNLOAD',
          Href: presigned
        }
      ];
    }

    return [];
  }, [presigned]);

  if (!links.length) {
    return null;
  }

  return (
    <AsyncLinks
      wrapper={wrapper}
      variant="list"
      tag={`Order ${orderId}`}
      links={links}
      title={title}
      match={(x) => x.Type.includes('ORDER-INVOICE_DOWNLOAD')}
    >
      {titleComponent}
    </AsyncLinks>
  );
};

export default OrderInvoice;
